const junipInterval = setInterval(reStructReview, 100);
var sliderWidth = 0;
var sliderTrackWidth = 0;
function reStructReview() {
  if ($(".junip-review-list-item-container").length) {
    if ($(".junip-see-more").length) {
      $(".junip-see-more").click(function () {
        setTimeout(reStructReview, 300);
      });
    }

    $(".junip-review-list-item-container").each(function () {
      var reviewDate = $(this).find(".junip-review-date");

      $(this).find(".junip-customer-container").append(reviewDate);

      $(this).find(".junip-separator").hide();
      $(".junip-see-more").html("MORE&nbsp;");

      // $('<div class="left-container"></div>').insertAfter(
      //   $(this).find(".junip-flex-wrapper")
      // );
      // var reviewTitle = $(this).find(".junip-review-title");
      // var reviewBodyContainer = $(this).find(".junip-review-body-container");
      // var reviewBody = $(this).find(".junip-review-body");
      // $(this).find('.left-container').append(reviewTitle).append(reviewBodyContainer).append(reviewBody);
    });

    clearInterval(junipInterval);
  }
  if ($(".junip-reviews-container").length) {
    $(this).find(".junip-separator").hide();
  }
}

$(document).ready(function () {

  

  
  // Add smooth scrolling to all links
  $(".menu-tablist-wrapper ul li a").on("click", function (event) {
    // Make sure this.hash has a value before overriding default behavior

    var elementId = $(this).attr("href");

    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;
      $(elementId).click();

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $("html").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {
          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash;
        }
      );
    } // End if
  });

  //Acordding item description
  $(".accordion-section .accordion-heading-item").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var htmlContent = $(this).find(".name-tag").html();
    if (!$this.hasClass("accordion-active")) {
      $(".accordion-content").slideUp(0);
      $(".accordion-heading-item").removeClass("accordion-active");
      $(".accordion-heading-icon").removeClass("accordion__rotate");
    }

    $this.toggleClass("accordion-active");
    $this.next().slideToggle();

    setTimeout(function () {
      $("html").animate(
        {
          scrollTop: $this.offset().top,
        },
        200
      );
    }, 250);

    $(".accordion-heading-icon", this).toggleClass("accordion__rotate");
    var elementId = $(this).attr("id");
    if (elementId == "how-to-use" && $this.hasClass("accordion-active")) {
      if ($(window).width() < 768 && $("video").hasClass("video-mobile")) {
        $("video")[1].play();
      } else {
        $("video")[0].play();
      }
    } else {
      if ($(window).width() < 768 && $("video").hasClass("video-mobile")) {
        $("video")[1].pause();
      } else {
        $("video")[0].pause();
      }
    }
    if ($(window).width() < 768) {
      var elementId = $(this).attr("id");
      var container = $(this).closest(".accordion-section");
      if (elementId == "ingredients") {
        $(".para-mobile-slide").find("p").remove();
        $(".para-mobile-slide").slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          arrows: false,
          dots: true,
        });

        if (sliderTrackWidth != 0) {
          container.find(".slick-track").css("width", sliderTrackWidth);
        }
        if (sliderWidth != 0) {
          container.find(".slick-slide").css("width", sliderTrackWidth);
        }

        setTimeout(function () {
          sliderWidth = container.find(".slick-slide").css("width");
          sliderTrackWidth = container.find(".slick-track").css("width");
        }, 500);
      }
    }
  });

  // $(".product__media-list").slick({
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 5000,
  //   arrows: false,
  //   dots: true,
  // });

  function removeInActiveVariantImage () {
    const currVariantId = document.querySelector('input.product-variant-id').value;
    const productImages = document.querySelectorAll(
      '.product__media-wrapper .slider__slide'
    );
  
    productImages.forEach(function (image) {
      const imageVariantId = image.getAttribute('data-variant-id');
  
      if (imageVariantId && imageVariantId !== currVariantId) {
        image.remove();
      }
    });
  }

  removeInActiveVariantImage();

  $(".product-related-wrapper").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
  });
  $('.product__media-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: '.slider-nav',
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
  });
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product__media-list',
    focusOnSelect: true,
    arrows: true,
  });
  

  $(".section").each(function () {
    var section = $(this);

    section.find(".btn-more").nextUntil(".btn-less").hide();
    section.find(".btn-less").hide();

    section.find(".btn-more").click(function () {
      section.find(".btn-more").nextUntil(".btn-less").slideDown();

      section.find(".btn-more").hide();
      section.find(".btn-less").show();
    });

    section.find(".btn-less").click(function () {
      section.find(".btn-more").nextUntil(".btn-less").slideUp();

      section.find(".btn-more").show();
      section.find(".btn-less").hide();
    });
  });
});

$(document).ready(function () {
  // top position of megamenu
  var annHeight = $(".announcement-bar-section").height();
  var menuHeight = $(".shopify-section-group-header-group").height();
  var ttlHeigth = annHeight + menuHeight + 52;
  $(
    ".desktop .header-content-main .parent-menu.active .submenu-hover-cstm"
  ).css("top", ttlHeigth);

  // setTimeout(function () {
  //   $(".yotpo-plans-and-policy-wrapper").css("display", "block");
  //   console.log($("body").hasClass("template-index"));

  //   var subscriptionHtml1 = $(
  //     ".template-index .section-product-related .product-form__buttons .yotpo-widget-subscriptions-add-to-cart"
  //   ).eq(1);
  //   $(".template-index .product-form__buttons")
  //     .eq(1)
  //     .prepend(subscriptionHtml1);

  //   var subscriptionHtml2 = $(
  //     ".template-index .section-product-related .product-form__buttons .yotpo-widget-subscriptions-add-to-cart"
  //   ).eq(1);
  //   $(".template-index .product-form__buttons")
  //     .eq(2)
  //     .prepend(subscriptionHtml2);

  //   var subscriptionHtml3 = $(
  //     ".template-product .product-form__buttons .yotpo-widget-subscriptions-add-to-cart"
  //   ).eq(0);
  //   $(".template-product .product-form__buttons")
  //     .eq(2)
  //     .prepend(subscriptionHtml3);

  //   var subscriptionHtml4 = $(
  //     ".template-product .product-form__buttons .yotpo-widget-subscriptions-add-to-cart"
  //   ).eq(0);
  //   $(".template-product .product-form__buttons")
  //     .eq(3)
  //     .prepend(subscriptionHtml4);

  //   var subscriptionHtml5 = $(
  //     ".template-product .product-form__buttons .yotpo-widget-subscriptions-add-to-cart"
  //   ).eq(0);
  //   $(".template-product .product-form__buttons")
  //     .eq(4)
  //     .prepend(subscriptionHtml5);
  // }, 2000);

  setTimeout(function () {
    var attr = $(".newsletter-popup").attr("open");
    if (typeof attr !== "undefined" && attr !== false) {
      $("body").addClass("popup-open");
    } else {
      $("body").removeClass("popup-open");
    }
  }, 1000);

  $("#close-popup").click(function () {
    $("body").removeClass("popup-open");
  });

  setTimeout(function () {
    $(".custom-reviews-content-main").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: false,
      prevArrow:
        "<img class='slick-arrows-cstm slick-prev' src='https://cdn.shopify.com/s/files/1/0736/5401/0175/files/arrow-left-svg.svg?v=1739545376'>",
      nextArrow:
        "<img class='slick-arrows-cstm slick-next' src='https://cdn.shopify.com/s/files/1/0736/5401/0175/files/arrow-right-svg.svg?v=1739545376'>"
    });
  }, 0);

  // function scrollToComments(prodHandle) {
  //   window.location.replace(
  //     "/products/" + prodHandle + "#yotpo-reviews-main-widget"
  //   );
  //   setTimeout(function () {
  //     window.location.replace(
  //       "/products/" + prodHandle + "#yotpo-reviews-main-widget"
  //     );
  //   }, 5000);
  // }

  function scrollToSection(id) {
    var element = document.getElementById(id);
    if (element) {
      element.scrollIntoView();
      $("#yotpo-main-widget-btn").click();
      var getUrl = window.location.href;
      var hashUrl = window.location.hash.substring(1);
      var newurl = getUrl.split("#");
      window.history.pushState("obj", "newtitle", newurl[0]);
    }
  }

  // Wait for the page to fully load

  window.addEventListener("load", function () {
    // Get the fragment identifier (e.g., #your-section-id)
    var fragmentId = window.location.hash.substring(1); // Remove the #
    if (fragmentId) {
      // Scroll to the section with the specified ID after a short delay (to ensure the page has fully loaded)
      setTimeout(function () {
        scrollToSection(fragmentId);
      }, 500); // Adjust the delay as needed
    }
  });

  $(document).on("click", ".review-button a", function (e) {
    e.preventDefault();
    var productHandle = $(this).attr("prod-handle");
    var productUrl = $(this).attr("href");
    window.location.href = `${productUrl}#yotpo-reviews-main-widget`;
  });

  $(document).on(
    "click",
    ".header-content.first-menu .parent-menu.has-child",
    function () {
      $('.header-content.first-menu .parent-menu.has-child').toggleClass("active");
      $('.header-content.first-menu .parent-menu').find(".product-container").toggle();
      $('.header-content.first-menu .parent-menu').find(".submenu-hover-cstm").toggle();
      $('.header-content.first-menu .parent-menu').find(".nav-slider").slick({
        infinite: true,
        slidesToShow: 4,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        },
          {
              breakpoint: 1024,
              settings: {
                  slidesToShow: 2
              }
          }
      ]
      });
    }
  );
  
  $(document).on("click", ".submenu-hover-cstm", function (event) {
    event.stopPropagation();
  });

  
  $(document).on("click", ".menuItem .parent", function () {
    $(this).prevAll(".child").slideUp();
    $(this).nextAll(".child").slideUp();
    $(this).toggleClass("active");
    $(this).find(".child").slideToggle();
  });


  $(document).on("click", "a#cart-icon-bubble", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("cart-drawer").addClass("active");
  });

  var maxHeight = 0;
  $('.review-content.slick-slide').each(function() {
      if ($(this).height() > maxHeight) {
          maxHeight = $(this).css('height');
          maxHeight = maxHeight.replace('px','');
          maxHeight = Number(maxHeight);
      }
  });
  $('.review-content.slick-slide').css('height', `${maxHeight}px`);

  $(window).resize(function(){
    var maxHeight = 0;
    $('.review-content.slick-slide').each(function() {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).css('height');
            maxHeight = maxHeight.replace('px','');
            maxHeight = Number(maxHeight);
        }
    });
    $('.review-content.slick-slide').css('height', `${maxHeight}px`);
  });

setTimeout(function(){ 
  $('.yotpo-reviewer-verified-buyer-text').text('Verified Buyer');
  $('.yotpo-reviewer-verified-buyer-text').show();
},1100);

setTimeout(function(){
$('.yotpo-select-wrapper').each(function(){
     $(this).find('.yotpo-frequency-options').find('input:first').click();
    });
},2000);
});


